/**
 * Form Validation System
 */

class FormValidator {
    constructor(formSelector) {
        this.form = document.querySelector(formSelector);
        if (!this.form) return;

        this.errors = {};
        this.init();
    }

    init() {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));

        // Real-time validation on blur
        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            field.addEventListener('blur', () => this.validateField(field));
            field.addEventListener('change', () => this.clearFieldError(field));
        });
    }

    validateField(field) {
        const value = field.value.trim();
        const formGroup = field.closest('.form-group');
        let isValid = true;
        let errorMessage = '';

        // Required
        if (field.required && !value) {
            isValid = false;
            errorMessage = `${this.getFieldLabel(field)} ist erforderlich.`;
        }

        // Email
        if (isValid && field.type === 'email' && value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                isValid = false;
                errorMessage = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
            }
        }

        // Min length
        if (isValid && field.minLength && value.length < field.minLength) {
            isValid = false;
            errorMessage = `Mindestens ${field.minLength} Zeichen erforderlich.`;
        }

        // Max length
        if (isValid && field.maxLength && field.maxLength > 0 && value.length > field.maxLength) {
            isValid = false;
            errorMessage = `Maximal ${field.maxLength} Zeichen erlaubt.`;
        }

        // Pattern
        if (isValid && field.pattern && value) {
            const pattern = new RegExp(field.pattern);
            if (!pattern.test(value)) {
                isValid = false;
                errorMessage = field.dataset.patternMessage || 'Ungültiges Format.';
            }
        }

        // Phone (optional pattern)
        if (isValid && field.type === 'tel' && value) {
            const phoneRegex = /^[\d\s\-\+\(\)]{10,}$/;
            if (!phoneRegex.test(value)) {
                isValid = false;
                errorMessage = 'Bitte geben Sie eine gültige Telefonnummer ein.';
            }
        }

        if (isValid) {
            this.clearFieldError(field);
            if (formGroup) {
                formGroup.classList.add('form-group--success');
            }
        } else {
            this.showFieldError(field, errorMessage);
        }

        return isValid;
    }

    showFieldError(field, message) {
        const formGroup = field.closest('.form-group');
        if (!formGroup) return;

        formGroup.classList.add('form-group--has-error');
        formGroup.classList.remove('form-group--success');

        let errorElement = formGroup.querySelector('.form-error');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'form-error';
            field.parentNode.insertBefore(errorElement, field.nextSibling);
        }

        errorElement.textContent = message;
        this.errors[field.name] = message;
    }

    clearFieldError(field) {
        const formGroup = field.closest('.form-group');
        if (!formGroup) return;

        formGroup.classList.remove('form-group--has-error');
        const errorElement = formGroup.querySelector('.form-error');
        if (errorElement) {
            errorElement.remove();
        }

        delete this.errors[field.name];
    }

    handleSubmit(e) {
        e.preventDefault();

        this.errors = {};
        let isFormValid = true;

        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            if (!this.validateField(field)) {
                isFormValid = false;
            }
        });

        if (isFormValid) {
            this.submitForm();
        } else {
            this.showFormAlert('error', 'Fehler', 'Bitte füllen Sie alle erforderlichen Felder korrekt aus.');
        }
    }

    submitForm() {
        // Hier könnte eine API-Anfrage erfolgen
        // this.showFormAlert('success', 'Erfolg', 'Das Formular wurde erfolgreich eingereicht!');
        this.form.submit();
    }

    showFormAlert(type, title, message) {
        let alertContainer = this.form.querySelector('.form-alert');

        if (!alertContainer) {
            alertContainer = document.createElement('div');
            alertContainer.className = `form-alert form-alert--${type}`;
            this.form.insertBefore(alertContainer, this.form.firstChild);
        }

        alertContainer.className = `form-alert form-alert--${type}`;
        alertContainer.innerHTML = `
          <div class="form-alert-title">${title}</div>
          <div class="form-alert-message">${message}</div>
        `;

        alertContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    getFieldLabel(field) {
        const label = this.form.querySelector(`label[for="${field.id}"]`);
        return label ? label.textContent.replace(/\*/, '').trim() : field.name;
    }
}

export default FormValidator;
